<template>
    <div
        class="d-flex border-top border-bottom bg-white"
        v-bind:class="{ 'fw-bold': isHeader }">
        <div
            v-for="(colOption, index) in visibleColumnOptions"
            v-bind:key="index"
            v-bind:style="getStyle(colOption)">
            {{ getDisplay(colOption) }}
        </div>
        <div class="dropstart menu-wrapper align-self-center">
            <template v-if="!isHeader">
                <pc-button
                    outline
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    class="menu-button"
                    style="min-width: 0">
                    <pc-bs-icon
                        name="three-dots-vertical"
                        class="menu-icon"
                        style="font-size: 1.5rem" />
                </pc-button>
                <div class="dropdown-menu">
                    <button
                        data-test-role="edit-rule"
                        class="dropdown-item"
                        v-on:click="onEdit">
                        {{ editText }}
                    </button>
                    <button
                        data-test-role="delete-rule"
                        class="dropdown-item"
                        type="button"
                        v-on:click="onDelete">
                        {{ deleteText }}
                    </button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { EDIT_AUTOMATION_TYPES } from "./editAutomationStore";
    import { KEYS, NAMESPACE } from "I18n/common.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        props: {
            columnOptions: { type: Array, required: true },
            rule: { type: Object, required: false, default: null },
            ruleType: { type: String, required: true },
            isHeader: { type: Boolean, required: false, default: false }
        },
        computed: {
            visibleColumnOptions() {
                return this.columnOptions.filter((option) => option.visible);
            },
            ...mapI18n(KEYS, NAMESPACE)
        },
        methods: {
            getDisplay(column) {
                if (this.isHeader) {
                    return column.header;
                }
                const propValue = this.rule[column.property];
                if (typeof column.displayValue === "function") {
                    return column.displayValue(propValue);
                }
                return propValue;
            },
            getStyle(column) {
                const style = {
                    "flex-shrink": "0",
                    width: `${column.width}px`,
                    padding: ".5rem .25rem"
                };
                if (column.break) {
                    style["overflow-wrap"] = "break-word";
                    style["word-break"] = "break-word";
                }
                return style;
            },
            onEdit() {
                this.$store.dispatch(EDIT_AUTOMATION_TYPES.actions.editRule, {
                    ruleId: this.rule.clientId,
                    ruleType: this.ruleType
                });
            },
            onDelete() {
                this.$store.commit(EDIT_AUTOMATION_TYPES.mutations.deleteRule, {
                    ruleType: this.ruleType,
                    ruleId: this.rule.clientId
                });
            }
        }
    };
</script>
<style lang="scss" scoped>
    $iconPadding: 0.25rem;
    $iconSize: 1.5rem;

    .menu-wrapper {
        flex-shrink: 0;
        // make sure that the width here matches the width in editRuleTable.columnOptions
        width: 28px;
        height: calc($iconPadding * 2 + $iconSize + var(--bs-border-width) * 2);
    }

    .menu-button {
        padding: $iconPadding;
    }

    .menu-icon {
        font-size: $iconSize;
        color: var(--bs-primary);
    }
</style>
